import React from "react";
import { YahooContent } from "../yahoo/YahooContent";
import { RollerAdsContent } from "../rollerads/RollerAdsContent";
import { AdProvider, useAdProvider } from "./useAdProvider";

interface AdContentProps {
  maxAds?: number;
  maxRS?: number;
  adIcon?: React.ReactNode;
  headerMessageId?: string;
}

export function AdContent({
  maxAds,
  maxRS,
  adIcon,
  headerMessageId,
}: AdContentProps) {
  const { provider } = useAdProvider();

  if (provider === AdProvider.ROLLER_ADS) {
    return <RollerAdsContent />;
  }

  return (
    <YahooContent
      maxAds={ maxAds }
      maxRS={ maxRS }
      adIcon={ adIcon }
      headerMessageId={ headerMessageId }
    />
  );
}
